import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    inactivo: false,
    rowVersion: null,

    viaticoRubro: null,
    tieneRendiciones: false,

    viaticoRubroDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, viaticoRubroId) {
        state.id = viaticoRubroId;
        state.nombre = '';
        state.currentNombre = '';
        state.inactivo = false;
        state.rowVersion = null;

        state.tieneRendiciones = false;
        state.viaticoRubro = null;
    },
    'SET_VIATICO_RUBRO' (state, viaticoRubro) {
        state.nombre= viaticoRubro.nombre;
        state.inactivo = viaticoRubro.inactivo;
        state.rowVersion = viaticoRubro.rowVersion;

        state.tieneRendiciones = (/true/i).test(viaticoRubro.tieneRendiciones);
        state.viaticoRubro = {
            nombre: viaticoRubro.nombre
        }
    },

    'INICIALIZAR_DATOS' (state) {
        state.viaticoRubroDatos = [];
    },
    'SET_DATOS' (state, viaticoRubroDatos) {
        state.viaticoRubroDatos = viaticoRubroDatos;
    },
};

const getters = {
    getField,

    validarCambioNombre(state) {
        if ((/true/i).test(state.tieneRendiciones)) {
            if (state.viaticoRubro) {
                if (state.viaticoRubro.nombre) {
                    return state.viaticoRubro.nombre.toUpperCase().trim() != state.nombre.toUpperCase().trim();
                }
            }
        }
        return false;
    }
};

const actions = {
    inicializar ( { commit }, viaticoRubroId ) {
        return new Promise((resolve, reject) => { 
            commit('INICIALIZAR', viaticoRubroId);

            if (viaticoRubroId != 0)
            {
                apiAxios.get('viaticos-rubros/' + viaticoRubroId + '/abm' ) 
                .then(res => {
                    commit('SET_VIATICO_RUBRO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let viaticoRubro= {
                nombre: state.nombre.toUpperCase().trim(),
                inactivo: state.inactivo
            }

            let url = 'viaticos-rubros';
            if (state.id != 0) {
                url += '/' + state.id;
                viaticoRubro.rowVersion= state.rowVersion;
            }

            apiAxios.post(url, viaticoRubro)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getDatos ( { commit }, viaticoRubroId ) {
        return new Promise((resolve, reject) => { 
            commit('INICIALIZAR_DATOS');

            apiAxios.get('viaticos-rubros/' + viaticoRubroId) 
            .then(res => {
                var datos = [
                    { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                    { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': (res.data.inactivo)? 'Si' : 'No', 'formato': '' },
                ];
                commit('SET_DATOS', datos);
                resolve()
            })
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}